<template>
  <div v-if="data">
    <Top />
    <div class="container container--mobile">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-sm">
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <br />
          <Pagination :numberOfDots="4" :numberOfVisitedDots="1" />
          <div class="header-wrapper margin-top-75">
            <h2 class="text-left text-primary-fh" v-html="data.optout.optoutHeader"></h2>
          </div>
          <p v-html="data.optout.optoutText"></p>
          <div class="margin-top-25"></div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <h4 class="text-primary-fh left-header" v-html="data.optout.areyousureHeader"></h4>
          <div class="margin-top-25"></div>
          <button class="btn btn-primary btn-lg btn-block" @click="denyConsent()">Ja</button>
          <div class="clearfix"></div>
          <router-link to="/welcome">
            <button class="btn btn-outline-secondary btn-lg btn-block">Nej</button>
          </router-link>
          <div class="clearfix"></div>
          <small v-html="data.optout.disclaimerText"></small>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'optout',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    toTitleCase (phrase) {
      return phrase
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
    denyConsent () {
      let loader = this.$loading.show()
      const consent = false
      axios.postConsent(config.consentUri + config.researchUri, consent).then((response) => {
        if (response) {
          loader.hide()
          if (sessionStorage.getItem('isIndexPatient') === 'true') {
            this.$router.push('/familytree')
          } else {
            this.$router.push('/confirm')
          }
        }
      }, (error) => {
        if (error.response && error.response.status === 401) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        } else {
          loader.hide()
          console.log(error)
        }
      })
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          optout {
            optoutHeader
            optoutText
            areyousureHeader
            disclaimerText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.margin-top-25 {
  margin-top: 25px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/OptOut.vue